module.exports = __webpack_public_path__ + "static/media/EraBanner.6b27af8e.png";